import classes from "./SavaTimer.module.css"
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DynamicMessage from "../Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../models/DynamicMessageTypeEnum";

const SaveTimer = ({ initialMinutes, initialHours, confirmFunc, initialFinish, setFinish }) => {
    const [hours, setHours] = useState(initialHours);
    const [minutes, setMinutes] = useState(initialMinutes);
    const [seconds, setSeconds] = useState(0);
    const { texts } = useSelector(state => state.translate);

    const getTime = () => {
        if (!initialFinish) {
            if (seconds !== 0)
                setSeconds(seconds - 1)
            if (seconds === 0 && minutes > 0) {
                setMinutes(minutes - 1);
                setSeconds(59)
            }
            else if (seconds === 0 && minutes === 0 && hours === 0) {
                setFinish(true)
            }
            if (minutes === 0 && hours > 0) {
                setHours(hours - 1)
                setMinutes(59)
            }
        }

    };

    useEffect(() => {
        setMinutes(initialMinutes)
        setHours(initialHours)
        setSeconds(0)
    }, [initialFinish])



    useEffect(() => {
        if (!initialFinish) {
            const interval = setInterval(() => getTime(), 1000);
            return () => clearInterval(interval);
        }
    }, [seconds, initialFinish]);

    const handleCancel = () => {
        sessionStorage.setItem("IgnoreSaveMessage", "true");
        setFinish(false);
    };

    return (
        <div /*className={classes.TimerWarrper}*/>
            {/* {`${minutes}:${seconds}`} */}
            {initialFinish && sessionStorage.getItem("IgnoreSaveMessage") !== "true" && (
                <DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    title={texts.dontSave}
                    content={texts.recomanddedToSave}
                    cancelFunc={() => setFinish(false)}
                    confirmText={texts.save}
                    otherText={texts.dontShowAgain}
                    otherFunc={handleCancel}
                    confirmFunc={confirmFunc}
                    showRestore={false}
                />
            )}
        </div>
    )
}
export default SaveTimer